const stickyHeaderZIndex = 1000

export enum ZIndex {
  stickyHeader = stickyHeaderZIndex,
  cookieConsent = stickyHeaderZIndex + 1,
}
